import React from 'react';
import { Script, ScriptStrategy } from 'gatsby';

export const ScriptsBefore = () => {
  const disableCookieYes = process.env.GATSBY_DISABLE_COOKIEYES === 'true';
  const LOAD_SURFLY = process.env.GATSBY_LOAD_SURFLY === 'true';
  const LOAD_LIVE_CHAT = process.env.GATSBY_LOAD_LIVE_CHAT === 'true';

  return (
    <>
      {/* GTM */}
      {!disableCookieYes && (
        <>
          <Script strategy={ScriptStrategy.postHydrate}>
            {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-PLT452CG');
          `}
          </Script>
        </>
      )}
      {/* // OneTrust Cookies Consent Notice */}
      {/* Optimise S2S Tracking Script */}
      <Script
        strategy={ScriptStrategy.postHydrate}
      >{`OMID=2361901;OPID=57131;ORef=encodeURIComponent(window.parent.location.href);!function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="//track.omguk.com/e/qs/?action=Content&MID=" + OMID + "&PID=" + OPID + "&ref=" + ORef;var b=document.getElementsByTagName("body")[0];if(b)b.appendChild(a,b);else{var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}}();`}</Script>
      {/* Surfly Script Integration */}
      {LOAD_SURFLY && (
        <>
          <Script
            src="https://surfly.com/surfly.js"
            strategy={ScriptStrategy.postHydrate}
            id="surfly-sdk"
            onLoad={() => {
              // This flag indicates the external Surfly script file itself has loaded.
              // It's used by the initialization logic below.
              if (!window.surflySDKLoaded) {
                window.surflySDKLoaded = true;
              }
            }}
            onError={() => {
              // Handle cases where the script itself fails to load (e.g., network error, 404)
              console.error(
                'Surfly SDK script file failed to load (onError triggered).',
              );
              window.surflySDKLoaded = false; // Indicate failure if needed
            }}
          />
          <Script strategy={ScriptStrategy.idle} id="surfly-init-logic">
            {`
            (function() {
              // Ensure this entire initialization block runs only once
              if (window.surflyInitialized) {
                return;
              }
              window.surflyInitialized = true; // Mark that this process has started
      
              const WIDGET_KEY = "${
                process.env.GATSBY_SURFLY_WIDGET_KEY || ''
              }";
              let currentSurflySession = null;

              function initSurfly() {
                if (!WIDGET_KEY) {
                  console.error('Surfly Widget Key (GATSBY_SURFLY_WIDGET_KEY) is not configured. Surfly will not initialize.');
                  return;
                }

                // This check is now more robust in checkAndInit, but a defensive check here is still okay.
                if (typeof window.Surfly === 'undefined' || typeof window.Surfly.init !== 'function') {
                  console.error('Surfly SDK (window.Surfly or window.Surfly.init) not available when initSurfly was called. This should have been caught by checkAndInit.');
                  return;
                }
                
                const surflySettings = {
                  widget_key: WIDGET_KEY,
                  block_until_agent_joins: false, 
                  hide_until_agent_joins: true,  
                  session_start_confirmation: false,
                  // MODIFICATION 1: Added on_error to surflySettings
                  on_error: function(errorData) {
                      console.error('Surfly SDK reported an error via settings.on_error:', errorData);
                  }
                };

                try {
                  window.Surfly.init(surflySettings, function(init) {
                    if (init.success) {
                      if (window.Surfly.isInsideSession) {
                        // Potentially sync currentSurflySession if needed
                        // currentSurflySession = window.Surfly.currentSession;
                        return;
                      }

                      window.startSurflySession = function(pinCallback, sessionEndCallback, errorCallback) { // Added errorCallback for consistency, though old logic might not use it fully
                        if (currentSurflySession) {
                          console.warn('Surfly: Session is already active or being started.');
                          if (currentSurflySession.pin && typeof pinCallback === 'function') {
                            pinCallback(currentSurflySession.pin);
                          }
                          return;
                        }
                        
                        try {
                          currentSurflySession = window.Surfly.session({}); // Pass session-specific settings here if any

                          currentSurflySession.on("session_created", function(sessionInfo, event) {
                            if (typeof pinCallback === 'function') {
                              pinCallback(sessionInfo.pin);
                            }
                          });

                          currentSurflySession.on("session_ended", function(sessionInfo, event) {
                            currentSurflySession = null;
                            if (typeof sessionEndCallback === 'function') {
                              sessionEndCallback();
                            }
                          });

                          currentSurflySession.on("error", function(sessionObj, eventError) { // Parameters might be (session, error) or just (error) depending on event
                            console.error('Surfly event: Session error:', eventError, 'Session obj:', sessionObj);
                            currentSurflySession = null; 
                            // Use the new errorCallback if provided
                            if (typeof errorCallback === 'function') {
                              errorCallback(eventError);
                            } else if (typeof sessionEndCallback === 'function') { 
                              // Fallback to old behavior if no specific error callback
                              sessionEndCallback();
                            }
                          });

                          currentSurflySession.startLeader();
                        } catch (sessionError) {
                          console.error('Surfly: Error creating or starting Surfly session:', sessionError);
                          currentSurflySession = null;
                          if (typeof errorCallback === 'function') {
                            errorCallback(sessionError);
                          } else if (typeof sessionEndCallback === 'function') {
                            sessionEndCallback();
                          }
                        }
                      };

                      window.endSurflySession = function() {
                        if (currentSurflySession) {
                          try {
                            currentSurflySession.end();
                            // currentSurflySession will be nulled by 'session_ended' event
                          } catch (endError) {
                            console.error('Surfly: Error calling currentSurflySession.end():', endError);
                            currentSurflySession = null; // Ensure cleanup
                          }
                        } else {
                        }
                      };

                    } else {
                      console.error('Surfly: Initialization failed (Surfly.init callback). Error:', init.error || 'Unknown error', 'Full init object:', init);
                    }
                  });
                  
                  // Fallback timeout in case the Surfly.init callback never fires or startSurflySession isn't defined
                  setTimeout(function() {
                    if (typeof window.startSurflySession === 'undefined') {
                      console.warn('Surfly: Init callback may not have fired or defined startSurflySession within 3 seconds. Defining fallback/stub functions.');
                      
                      window.startSurflySession = function(pinCallback, sessionEndCallback, errorCallback) {
                        console.error('Surfly: Fallback startSurflySession - Surfly initialization likely failed or timed out, session cannot be started.');
                        if (typeof errorCallback === 'function') {
                          errorCallback(new Error('Surfly init fallback timeout'));
                        } else if (typeof sessionEndCallback === 'function') {
                          sessionEndCallback();
                        }
                      };

                      window.endSurflySession = function() {
                        console.error('Surfly: Fallback endSurflySession - Surfly not properly initialized.');
                      };
                    }
                  }, 3000); // 3 seconds
                  
                } catch (initError) {
                  console.error('Surfly: Critical error during window.Surfly.init() call:', initError);
                }
              }
              
              // Polling function to wait for Surfly SDK to be available
              let attempts = 0;
              const maxAttempts = 10; // Try for 5 seconds (10 attempts * 500ms interval)
              const interval = 500;   // ms

              function checkAndInit() {
                attempts++;
                // MODIFICATION 2: Enhanced the condition to check for Surfly.init function
                if (window.surflySDKLoaded && typeof window.Surfly !== 'undefined' && typeof window.Surfly.init === 'function') {
                  initSurfly();
                } else if (attempts < maxAttempts) {
                  setTimeout(checkAndInit, interval);
                } else {
                  console.error(\`Surfly: Timeout. SDK did not load or Surfly.init not available after \${(maxAttempts * interval / 1000)} seconds (\${attempts} attempts). Surfly will not be initialized. SDKLoaded: \${!!window.surflySDKLoaded}, SurflyObject: \${typeof window.Surfly}, SurflyInit: \${typeof window.Surfly === 'object' && window.Surfly ? typeof window.Surfly.init : 'N/A'}\`);
                  // Define stubs if timeout occurs before init, to prevent errors if called
                  if (typeof window.startSurflySession === 'undefined') {
                    window.startSurflySession = function(pinCb, endCb, errCb) { console.error('Surfly: startSurflySession (stub) - SDK did not initialize.'); if(typeof errCb === 'function') errCb(new Error('Surfly SDK init timeout')); else if(typeof endCb === 'function') endCb();};
                    window.endSurflySession = function() { console.error('Surfly: endSurflySession (stub) - SDK did not initialize.'); };
                  }
                }
              }
              
              // Start the check. It relies on window.surflySDKLoaded being set by the <Script onLoad>
              checkAndInit();

            })();
          `}
          </Script>
        </>
      )}

      {LOAD_LIVE_CHAT && (
        <Script
          strategy={ScriptStrategy.postHydrate}
          id="cxone-init-and-cobrowse-trigger"
        >
          {`
              if (!window.cxoneGlobalSetupStarted) {
              // Ensure this CXone initialization and event listener setup runs only once
                window.cxoneGlobalSetupStarted = true;

                // 1. CXone Loader
                (function(n, u) {
                  window.CXoneDfo = n;
                  window[n] = window[n] || function() {
                    (window[n].q = window[n].q || []).push(arguments);
                  };
                  window[n].u = u;
                  
                  var loaderScriptId = 'cxone-loader-script';
                  if (!document.getElementById(loaderScriptId)) {
                    e.id = loaderScriptId;
                    var e = document.createElement("script");
                    e.type = "module";
                    e.src = u + "?" + Math.round(Date.now() / 1e3 / 3600); // Cache-busting
                    document.head.appendChild(e);
                  } else {
                  }
                })('cxone', 'https://web-modules-de-uk1.niceincontact.com/loader/1/loader.js');

                // 2. Queue CXone Initialization Commands & Setup Cobrowse Listener
                // This function will be executed once the cxone loader pattern is established.
                function setupCxOneInteractions() {
                  try {
                    // Queue CXone initialization commands
                    cxone('init', '1332');
                    // Allow specific message types, crucial for receiving the #COBRO# message
                    cxone('chat', 'setAllowedExternalMessageTypes', ['MESSAGE_SENT', 'MESSAGE_RECEIVED']);

                    // 3. Add Cobrowse Trigger Event Listener (if not already added)
                    cxone('chat', 'setAllowedExternalMessageTypes', ['MESSAGE_SENT', 'MESSAGE_RECEIVED']);
                    cxone('chat', 'init', 1332, 'chat_fb794066-1d52-4fb1-8127-4096f98b87b1');
                    if (!window.cxoneCobrowseMessageListenerAdded) {
                      window.addEventListener("message", function(event) {
                        if (event.data && 
                        // Basic validation of the event structure
                            event.data.action && 
                            typeof event.data.action.message === 'string') {
                          
                          
                            event.data.actionType === "MESSAGE_RECEIVED" && 
                          const messageContent = event.data.action.message;
                          if (messageContent.trim() === "#COBRO#") {
                            
                            if (typeof window.startSurflySession === 'function') {
                              // Call the globally available Surfly session starter function
                              window.startSurflySession(
                                function(pin) { // pinCallback
                                  // TODO: Implement sending PIN back to chat agent if needed and CXone supports it.
                                },
                                function() { // sessionEndCallback
                                },
                                function(error) { // errorCallback
                                  console.error("CXone Live Chat via Surfly: Error during Surfly session:", error);
                                }
                              );
                            } else {
                              console.warn("CXone Live Chat: Surfly function 'window.startSurflySession' not found. CoBrowse cannot be initiated. Ensure Surfly script (if used) is loaded and initialized correctly.");
                            }
                          }
                        }
                      });
                      window.cxoneCobrowseMessageListenerAdded = true;
                    }
                  } catch (error) {
                    console.error('CXone Live Chat: Error during setupCxOneInteractions:', error);
                  }
                }
                // The CXone loader pattern queues commands if 'cxone' isn't ready.

                // So, we can call this immediately.
                setupCxOneInteractions();

              } else {
              }
            `}
        </Script>
      )}
    </>
  );
};
